import BinderContractTable from 'components/features/binder-contract-table';
import HomeLayout from 'layouts/home-layout';
import { useTranslation } from 'react-i18next';

const ViewBinderContract = () => {
  const { t } = useTranslation();
  return (
    <HomeLayout title={t('contract.contracts')}>
      <BinderContractTable />
    </HomeLayout>
  );
};

export default ViewBinderContract;
